import { sw_reload_start } from './sync';

export const requestClientsReload = () => dispatch => {
  dispatch(sw_reload_start());
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage('reloadRequest');
  }
};
